<ng-container *transloco="let t">
  <app-strategy-overlay>
    @if (strategy) {
      <app-strategy-page [campaignType]="CampaignType.SD" [strategy]="strategy" [withTacticSection]="false">
        <app-strategy-asins [strategy]="strategy" withAsins [isReadOnly]="isReadOnly" />
        <div withSdTargetings>
          <div class="my-0 pt-2">
            <div class="flex flex-col gap-3">
              @if (!strategy.disableOtherQueries) {
                <app-sd-targeting
                  [defaultTactic]="true"
                  [strategy]="strategy"
                  [isReadOnly]="isReadOnly"
                  [isLastTargeting]="isLastTargeting"
                  [organizationId]="organizationId"
                ></app-sd-targeting>
              }
              @for (tactic of filterBlacklist(strategy.tactics, true); track tactic) {
                <app-sd-targeting
                  [tactic]="tactic"
                  [strategy]="strategy"
                  [isReadOnly]="isReadOnly"
                  [isLastTargeting]="isLastTargeting"
                  [organizationId]="organizationId"
                ></app-sd-targeting>
              }
              @for (tactic of filterBlacklist(strategy.tactics, false); track tactic) {
                <app-sd-targeting
                  [tactic]="tactic"
                  [strategy]="strategy"
                  [isReadOnly]="isReadOnly"
                  [isLastTargeting]="isLastTargeting"
                  [organizationId]="organizationId"
                ></app-sd-targeting>
              }
              @for (audience of strategy.audienceTargetings; track audience) {
                <app-sd-targeting
                  [audience]="audience"
                  [strategy]="strategy"
                  [isReadOnly]="isReadOnly"
                  [isLastTargeting]="isLastTargeting"
                  [organizationId]="organizationId"
                ></app-sd-targeting>
              }
              <IButton
                color="white"
                label="{{ t('sd-page.add_a_targeting') }}"
                [icon]="ICON_ADD"
                [disabled]="isReadOnly"
                (onClick)="createTargeting()"
              />
            </div>
          </div>
        </div>
      </app-strategy-page>
    }
  </app-strategy-overlay>
</ng-container>
